/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <ion-page class="ion-page">
    <ion-header class="ion-no-border">
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-back-button></ion-back-button>
        </ion-buttons>
        <h1 class="ion-text-center">{{ $t('Register.title')}}</h1>
      </ion-toolbar>
    </ion-header>

    <ion-content color="primary" forceOverscroll="false" class="no-scroll">
      <div class="mc-white-container" style="height: 100%">
        <Slider ref="slider" :key="refresh" v-bind:slides="slides" v-on:save="register()"></Slider>
      </div>

      <div class="sso-buttons" v-if="showButton">
        <div v-for="ssoButton in ssoButtons">
          <ion-button class='mc-small-button' color="success" expand="block" @click="loginSSO(ssoButton)">
            <ion-icon size="large" class="rotating" v-if="$store.state.userStore.status == 'loading'" name="sync"></ion-icon>
            <span v-if="$store.state.userStore.status != 'loading'">{{ $t('Login.' + ssoButton.ssoProvider) }}</span>
          </ion-button>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<style lang="scss">
.sso-buttons{
  position: absolute;
  bottom: 20px;
  left: 20px;
  max-width: 60%;
}
</style>

<script>
import Slider from "../../Shared/View/Slider.view";
import { shallowRef } from 'vue'
import { toast } from "../../Shared/Mixin/toast.mixin";
import RegisterStep1 from "../../Carpools/Register/RegisterStep1.view";
import RegisterStep2 from "../../Carpools/Register/RegisterStep2.view";

export default {
  name: "register",
  mixins: [toast],
  components: {
    Slider
  },
  data() {
    return {
      slides: [
        { title: "", component: shallowRef(RegisterStep1) },
        { title: "", component: shallowRef(RegisterStep2) }
      ],
      refresh: 0,
      sso: JSON.parse(process.env.VUE_APP_SSO),
      showMob: JSON.parse(process.env.VUE_APP_MOB),
      ssoButtons: [],
      showButton: true
    };
  },
  created() {
    this.$store.commit("init_sliderloader_visibility");
    if (!this.user) {
      this.$store.commit("register_reset");
    }

    if (this.sso) {
      this.$store.dispatch('sso_connections').then((res) => {
        if (res && res.length > 0) {
          const providers = JSON.parse(process.env.VUE_APP_SSO_LOGIN_PROVIDER)
          if (providers && providers.length > 0) {
            this.ssoButtons = res.filter(item => providers.includes(item.ssoProvider));
          } else {
            this.ssoButtons = res;
          }

        }
      });
    }
  },
  mounted() {
    if (this.sso) {
      this.$watch(() => {return this.$refs.slider.$data.activeIndex},
        (val) => {this.showButton = val == 0});
    }
  },
  computed: {
    user: {
      get() {
        return this.$store.state.registerStore.userToRegister;
      },
      set() {
        this.$store.commit("register_update", this.user);
      }
    }
  },
  methods: {
    register() {
      const email = this.$store.state.registerStore.userToRegister.email;
      this.$store.commit("change_sliderloader_visibility");
      this.user.hitchHikeDriver = null;
      this.user.hitchHikePassenger = null;
      this.$store
        .dispatch("register")
        .then(res => {
          if(JSON.parse(process.env.VUE_APP_GTAG_ACTIVATED)) {
            if (!!window.gtag) {
              gtag('event', 'conversion', {
                'allow_custom_scripts': true,
                'send_to': 'DC-8013475/movici/movic0+standard'
              });
            }
          }
          this.$store.commit("register_reset");
          this.$router.push('home');
          this.$router.push({path: "/confirm-registration/" + email});
          this.presentToast(this.$t("Register.success"), "success");
          this.$store.commit("change_sliderloader_visibility");
          // reload the component
          this.refresh++
        })
        .catch(err => {
          this.presentToast(this.$t("Commons.error"), "danger");
          this.$store.commit("change_sliderloader_visibility");
        });
    },
    loginSSO: function(sso) {
      let uri = sso.uri;
      window.open(uri, '_system');
    },
  }
};
</script>
